import Cookies from 'js-cookie';

function conditionalSetCookie (key, value) {
    const cookieDurationDays = 365;

    if (value) {
        Cookies.set(key, value, { expires: cookieDurationDays });
    }
}

function set (geoLocation) {
    conditionalSetCookie('je-last_latitude_used', geoLocation.latitude);
    conditionalSetCookie('je-last_longitude_used', geoLocation.longitude);
    conditionalSetCookie('je-last_street_used', geoLocation.street);
    conditionalSetCookie('je-last_houseNo_used', geoLocation.streetNumber);
    conditionalSetCookie('je-last_city_used', geoLocation.city);
    conditionalSetCookie('je-location', geoLocation.postCode);
}

function get () {
    return {
        latitude: Number(Cookies.get('je-last_latitude_used')),
        longitude: Number(Cookies.get('je-last_longitude_used')),
        street: Cookies.get('je-last_street_used'),
        streetNumber: Cookies.get('je-last_houseNo_used'),
        city: Cookies.get('je-last_city_used'),
        postCode: Cookies.get('je-location')
    };
}

export default { get, set };
